import http from './http' // needs this file in the same directory

export default {
  index(filter){
    return http.get(`/tags`, {params: {model: filter["model"]}});
  }
}